export function persistQueryString(){
    var search = location.search.substring(1);
    var obj: { [key: string]: string } = {};
    var pairs = search.split("&");
    for (var i in pairs) {
        var pair = pairs[i].split("=");
        obj[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }

    localStorage.setItem('queryString', JSON.stringify(obj));
    return obj;
}
persistQueryString();
